import { render, staticRenderFns } from "./VideoSlider.vue?vue&type=template&id=09d79988&scoped=true&"
import script from "./VideoSlider.vue?vue&type=script&lang=js&"
export * from "./VideoSlider.vue?vue&type=script&lang=js&"
import style0 from "./VideoSlider.vue?vue&type=style&index=0&id=09d79988&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d79988",
  null
  
)

export default component.exports